import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 27 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1.069 4a3.5 3.5 0 013.5-3.5h18.015a3.5 3.5 0 013.5 3.5v25a3.5 3.5 0 01-3.5 3.5H4.57a3.5 3.5 0 01-3.5-3.5V4z" fill="#fff" stroke="#7084E9" /><path stroke="#FFB50D" strokeWidth="1.5" strokeLinecap="round" d="M5.482 8.25h16.19M5.482 20.25h16.19M5.482 14.25h16.19M5.482 26.25h16.19" /></svg>);